module.exports = __webpack_public_path__ + "assets/img/zh-Hant-0ce38d01.png";